/**
 * L'envoi d'une pièce du signalement, sur le web : le fichier choisi (une adresse `blob:`) est déjà en
 * mémoire du navigateur ; on le lit pour connaître son type et son poids, puis il part au stockage par
 * le `PUT` présigné, lu (`verifyUpload`). Le mobile envoie depuis le disque (`issueReportUpload.ts`).
 */
import { API_URL } from "../../../../../../data/constants/apiConstants"
import { vaporStore } from "../../../../../../data/services/vaporService"
import { fetchResourceFromURI } from "../../../../../../data/utility/fileFromURI"
import type { PreparedAttachment, PickedAttachment } from "./issueReportAttachments"

export async function prepareIssueAttachment(picked: PickedAttachment): Promise<PreparedAttachment> {
    const blob: { type?: string; size?: number } = await fetchResourceFromURI(picked.uri)
    return {
        type: blob.type,
        size: blob.size,
        send: (contentType) => vaporStore(blob, { baseURL: API_URL, contentType, verifyUpload: true }),
    }
}
